import { render, staticRenderFns } from "./ModelParameter.vue?vue&type=template&id=427d6483&"
import script from "./ModelParameter.vue?vue&type=script&lang=ts&"
export * from "./ModelParameter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports